import Vue from "vue";
import Vuebar from "vuebar"; // custom scrollbar :: http://github.serafin.io/vuebar/#examples

Vue.use(Vuebar);
